const ToastContainer = ({ children }) => {
  return (
    <div className="fixed top-4 right-4 z-[100] space-y-3">
      {children}
    </div>
  );
};

export default ToastContainer;
